import * as React from 'react';

export function CloseIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00008 9.41423L14.293 15.7071L15.7072 14.2929L9.41429 8.00001L15.7072 1.70712L14.293 0.292908L8.00008 6.5858L1.70718 0.292908L0.292969 1.70712L6.58586 8.00001L0.292969 14.2929L1.70718 15.7071L8.00008 9.41423Z"
        fill="#737A8E"
      />
    </svg>
  );
}
